"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Preference Service
 * Preference API endpoints usage
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesControllerApi = exports.PreferencesControllerApiFactory = exports.PreferencesControllerApiFp = exports.PreferencesControllerApiAxiosParamCreator = exports.HealthApi = exports.HealthApiFactory = exports.HealthApiFp = exports.HealthApiAxiosParamCreator = exports.FiltersControllerApi = exports.FiltersControllerApiFactory = exports.FiltersControllerApiFp = exports.FiltersControllerApiAxiosParamCreator = exports.PermissionDtoAccessLevelEnum = exports.AccessDto = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var AccessDto;
(function (AccessDto) {
    AccessDto["Owner"] = "owner";
    AccessDto["View"] = "view";
})(AccessDto || (exports.AccessDto = AccessDto = {}));
/**
    * @export
    * @enum {string}
    */
var PermissionDtoAccessLevelEnum;
(function (PermissionDtoAccessLevelEnum) {
    PermissionDtoAccessLevelEnum["Owner"] = "owner";
    PermissionDtoAccessLevelEnum["Viewer"] = "viewer";
})(PermissionDtoAccessLevelEnum || (exports.PermissionDtoAccessLevelEnum = PermissionDtoAccessLevelEnum = {}));
/**
 * FiltersControllerApi - axios parameter creator
 * @export
 */
var FiltersControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerCreate: function (createFilterDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFilterDto_1], args_1, true), void 0, function (createFilterDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFilterDto' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerCreate', 'createFilterDto', createFilterDto);
                            localVarPath = "/v1/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFilterDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerDeleteById: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerDeleteById', 'id', id);
                            localVarPath = "/v1/filters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerFindAll: function (product_1, itemGroup_1, market_1, namespace_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, itemGroup_1, market_1, namespace_1], args_1, true), void 0, function (product, itemGroup, market, namespace, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (product !== undefined) {
                                localVarQueryParameter['product'] = product;
                            }
                            if (itemGroup !== undefined) {
                                localVarQueryParameter['item_group'] = itemGroup;
                            }
                            if (market !== undefined) {
                                localVarQueryParameter['market'] = market;
                            }
                            if (namespace !== undefined) {
                                localVarQueryParameter['namespace'] = namespace;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerUpdateById: function (id_1, updateFilterDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, updateFilterDto_1], args_1, true), void 0, function (id, updateFilterDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerUpdateById', 'id', id);
                            // verify required parameter 'updateFilterDto' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerUpdateById', 'updateFilterDto', updateFilterDto);
                            localVarPath = "/v1/filters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFilterDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2Create: function (createFilterDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFilterDto_1], args_1, true), void 0, function (createFilterDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFilterDto' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerV2Create', 'createFilterDto', createFilterDto);
                            localVarPath = "/v2/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFilterDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2DeleteById: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerV2DeleteById', 'id', id);
                            localVarPath = "/v2/filters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2FindAll: function (product_1, itemGroup_1, market_1, namespace_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, itemGroup_1, market_1, namespace_1], args_1, true), void 0, function (product, itemGroup, market, namespace, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v2/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (product !== undefined) {
                                localVarQueryParameter['product'] = product;
                            }
                            if (itemGroup !== undefined) {
                                localVarQueryParameter['item_group'] = itemGroup;
                            }
                            if (market !== undefined) {
                                localVarQueryParameter['market'] = market;
                            }
                            if (namespace !== undefined) {
                                localVarQueryParameter['namespace'] = namespace;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2UpdateById: function (id_1, updateFilterDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, updateFilterDto_1], args_1, true), void 0, function (id, updateFilterDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerV2UpdateById', 'id', id);
                            // verify required parameter 'updateFilterDto' is not null or undefined
                            (0, common_1.assertParamExists)('filtersControllerV2UpdateById', 'updateFilterDto', updateFilterDto);
                            localVarPath = "/v2/filters/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFilterDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FiltersControllerApiAxiosParamCreator = FiltersControllerApiAxiosParamCreator;
/**
 * FiltersControllerApi - functional programming interface
 * @export
 */
var FiltersControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FiltersControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerCreate: function (createFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerCreate(createFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerDeleteById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerDeleteById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerFindAll: function (product, itemGroup, market, namespace, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerFindAll(product, itemGroup, market, namespace, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerUpdateById: function (id, updateFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerUpdateById(id, updateFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2Create: function (createFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerV2Create(createFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2DeleteById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerV2DeleteById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2FindAll: function (product, itemGroup, market, namespace, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerV2FindAll(product, itemGroup, market, namespace, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2UpdateById: function (id, updateFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filtersControllerV2UpdateById(id, updateFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FiltersControllerApiFp = FiltersControllerApiFp;
/**
 * FiltersControllerApi - factory interface
 * @export
 */
var FiltersControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FiltersControllerApiFp)(configuration);
    return {
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerCreate: function (createFilterDto, options) {
            return localVarFp.filtersControllerCreate(createFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerDeleteById: function (id, options) {
            return localVarFp.filtersControllerDeleteById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerFindAll: function (product, itemGroup, market, namespace, options) {
            return localVarFp.filtersControllerFindAll(product, itemGroup, market, namespace, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerUpdateById: function (id, updateFilterDto, options) {
            return localVarFp.filtersControllerUpdateById(id, updateFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * creates a filters object
         * @param {CreateFilterDto} createFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2Create: function (createFilterDto, options) {
            return localVarFp.filtersControllerV2Create(createFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * deletes filter for a given filter id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2DeleteById: function (id, options) {
            return localVarFp.filtersControllerV2DeleteById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * gets a collection of filters objects
         * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
         * @param {string} [itemGroup]
         * @param {string} [market]
         * @param {string} [namespace]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2FindAll: function (product, itemGroup, market, namespace, options) {
            return localVarFp.filtersControllerV2FindAll(product, itemGroup, market, namespace, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * updates filter for a given filter id
         * @param {string} id
         * @param {UpdateFilterDto} updateFilterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerV2UpdateById: function (id, updateFilterDto, options) {
            return localVarFp.filtersControllerV2UpdateById(id, updateFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FiltersControllerApiFactory = FiltersControllerApiFactory;
/**
 * FiltersControllerApi - object-oriented interface
 * @export
 * @class FiltersControllerApi
 * @extends {BaseAPI}
 */
var FiltersControllerApi = /** @class */ (function (_super) {
    __extends(FiltersControllerApi, _super);
    function FiltersControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * creates a filters object
     * @param {CreateFilterDto} createFilterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerCreate = function (createFilterDto, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerCreate(createFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * deletes filter for a given filter id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerDeleteById = function (id, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerDeleteById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * gets a collection of filters objects
     * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
     * @param {string} [itemGroup]
     * @param {string} [market]
     * @param {string} [namespace]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerFindAll = function (product, itemGroup, market, namespace, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerFindAll(product, itemGroup, market, namespace, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * updates filter for a given filter id
     * @param {string} id
     * @param {UpdateFilterDto} updateFilterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerUpdateById = function (id, updateFilterDto, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerUpdateById(id, updateFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * creates a filters object
     * @param {CreateFilterDto} createFilterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerV2Create = function (createFilterDto, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerV2Create(createFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * deletes filter for a given filter id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerV2DeleteById = function (id, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerV2DeleteById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * gets a collection of filters objects
     * @param {string} [product] CP product the filter is associated with, i.e. \&quot;NEWRON\&quot; or \&quot;CIE\&quot;
     * @param {string} [itemGroup]
     * @param {string} [market]
     * @param {string} [namespace]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerV2FindAll = function (product, itemGroup, market, namespace, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerV2FindAll(product, itemGroup, market, namespace, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * updates filter for a given filter id
     * @param {string} id
     * @param {UpdateFilterDto} updateFilterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersControllerApi
     */
    FiltersControllerApi.prototype.filtersControllerV2UpdateById = function (id, updateFilterDto, options) {
        var _this = this;
        return (0, exports.FiltersControllerApiFp)(this.configuration).filtersControllerV2UpdateById(id, updateFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FiltersControllerApi;
}(base_1.BaseAPI));
exports.FiltersControllerApi = FiltersControllerApi;
/**
 * HealthApi - axios parameter creator
 * @export
 */
var HealthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuatorHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/actuator/health/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthApiAxiosParamCreator = HealthApiAxiosParamCreator;
/**
 * HealthApi - functional programming interface
 * @export
 */
var HealthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthApiAxiosParamCreator)(configuration);
    return {
        /**
         * health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuatorHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.actuatorHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthApiFp = HealthApiFp;
/**
 * HealthApi - factory interface
 * @export
 */
var HealthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthApiFp)(configuration);
    return {
        /**
         * health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuatorHealthGet: function (options) {
            return localVarFp.actuatorHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthApiFactory = HealthApiFactory;
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
var HealthApi = /** @class */ (function (_super) {
    __extends(HealthApi, _super);
    function HealthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    HealthApi.prototype.actuatorHealthGet = function (options) {
        var _this = this;
        return (0, exports.HealthApiFp)(this.configuration).actuatorHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthApi;
}(base_1.BaseAPI));
exports.HealthApi = HealthApi;
/**
 * PreferencesControllerApi - axios parameter creator
 * @export
 */
var PreferencesControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * creates a preference
         * @param {string} product
         * @param {string} preferenceType
         * @param {CreatePreferenceDto} createPreferenceDto
         * @param {boolean} [allowMultiple]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerCreate: function (product_1, preferenceType_1, createPreferenceDto_1, allowMultiple_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, createPreferenceDto_1, allowMultiple_1], args_1, true), void 0, function (product, preferenceType, createPreferenceDto, allowMultiple, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerCreate', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerCreate', 'preferenceType', preferenceType);
                            // verify required parameter 'createPreferenceDto' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerCreate', 'createPreferenceDto', createPreferenceDto);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (allowMultiple !== undefined) {
                                localVarQueryParameter['allowMultiple'] = allowMultiple;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPreferenceDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * deletes preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeleteById: function (product_1, preferenceType_1, id_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, id_1], args_1, true), void 0, function (product, preferenceType, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeleteById', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeleteById', 'preferenceType', preferenceType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeleteById', 'id', id);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}/{id}"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * deletes a user\'s permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeletePermission: function (product_1, preferenceType_1, id_1, userId_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, id_1, userId_1], args_1, true), void 0, function (product, preferenceType, id, userId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeletePermission', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeletePermission', 'preferenceType', preferenceType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeletePermission', 'id', id);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerDeletePermission', 'userId', userId);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}/{id}/permissions"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * gets a collection of preference objects
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} [namespace]
         * @param {boolean} [shared]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerFindAll: function (product_1, preferenceType_1, namespace_1, shared_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, namespace_1, shared_1], args_1, true), void 0, function (product, preferenceType, namespace, shared, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerFindAll', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerFindAll', 'preferenceType', preferenceType);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (namespace !== undefined) {
                                localVarQueryParameter['namespace'] = namespace;
                            }
                            if (shared !== undefined) {
                                localVarQueryParameter['shared'] = shared;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * gets the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerGetPermissions: function (product_1, preferenceType_1, id_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, id_1], args_1, true), void 0, function (product, preferenceType, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerGetPermissions', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerGetPermissions', 'preferenceType', preferenceType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerGetPermissions', 'id', id);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}/{id}/permissions"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * updates the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {Set<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerPatchPermissions: function (product_1, preferenceType_1, id_1, requestBody_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, id_1, requestBody_1], args_1, true), void 0, function (product, preferenceType, id, requestBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerPatchPermissions', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerPatchPermissions', 'preferenceType', preferenceType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerPatchPermissions', 'id', id);
                            // verify required parameter 'requestBody' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerPatchPermissions', 'requestBody', requestBody);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}/{id}/permissions"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * updates preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {UpdatePreferenceDto} updatePreferenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerUpdateById: function (product_1, preferenceType_1, id_1, updatePreferenceDto_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([product_1, preferenceType_1, id_1, updatePreferenceDto_1], args_1, true), void 0, function (product, preferenceType, id, updatePreferenceDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'product' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerUpdateById', 'product', product);
                            // verify required parameter 'preferenceType' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerUpdateById', 'preferenceType', preferenceType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerUpdateById', 'id', id);
                            // verify required parameter 'updatePreferenceDto' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesControllerUpdateById', 'updatePreferenceDto', updatePreferenceDto);
                            localVarPath = "/v1/preferences/{product}/{preferenceType}/{id}"
                                .replace("{".concat("product", "}"), encodeURIComponent(String(product)))
                                .replace("{".concat("preferenceType", "}"), encodeURIComponent(String(preferenceType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePreferenceDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PreferencesControllerApiAxiosParamCreator = PreferencesControllerApiAxiosParamCreator;
/**
 * PreferencesControllerApi - functional programming interface
 * @export
 */
var PreferencesControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreferencesControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         * creates a preference
         * @param {string} product
         * @param {string} preferenceType
         * @param {CreatePreferenceDto} createPreferenceDto
         * @param {boolean} [allowMultiple]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerCreate: function (product, preferenceType, createPreferenceDto, allowMultiple, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerCreate(product, preferenceType, createPreferenceDto, allowMultiple, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * deletes preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeleteById: function (product, preferenceType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerDeleteById(product, preferenceType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * deletes a user\'s permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeletePermission: function (product, preferenceType, id, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerDeletePermission(product, preferenceType, id, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * gets a collection of preference objects
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} [namespace]
         * @param {boolean} [shared]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerFindAll: function (product, preferenceType, namespace, shared, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerFindAll(product, preferenceType, namespace, shared, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * gets the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerGetPermissions: function (product, preferenceType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerGetPermissions(product, preferenceType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * updates the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {Set<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerPatchPermissions: function (product, preferenceType, id, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerPatchPermissions(product, preferenceType, id, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * updates preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {UpdatePreferenceDto} updatePreferenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerUpdateById: function (product, preferenceType, id, updatePreferenceDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesControllerUpdateById(product, preferenceType, id, updatePreferenceDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PreferencesControllerApiFp = PreferencesControllerApiFp;
/**
 * PreferencesControllerApi - factory interface
 * @export
 */
var PreferencesControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreferencesControllerApiFp)(configuration);
    return {
        /**
         * creates a preference
         * @param {string} product
         * @param {string} preferenceType
         * @param {CreatePreferenceDto} createPreferenceDto
         * @param {boolean} [allowMultiple]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerCreate: function (product, preferenceType, createPreferenceDto, allowMultiple, options) {
            return localVarFp.preferencesControllerCreate(product, preferenceType, createPreferenceDto, allowMultiple, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * deletes preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeleteById: function (product, preferenceType, id, options) {
            return localVarFp.preferencesControllerDeleteById(product, preferenceType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * deletes a user\'s permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerDeletePermission: function (product, preferenceType, id, userId, options) {
            return localVarFp.preferencesControllerDeletePermission(product, preferenceType, id, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * gets a collection of preference objects
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} [namespace]
         * @param {boolean} [shared]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerFindAll: function (product, preferenceType, namespace, shared, options) {
            return localVarFp.preferencesControllerFindAll(product, preferenceType, namespace, shared, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * gets the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerGetPermissions: function (product, preferenceType, id, options) {
            return localVarFp.preferencesControllerGetPermissions(product, preferenceType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * updates the permissions for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {Set<object>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerPatchPermissions: function (product, preferenceType, id, requestBody, options) {
            return localVarFp.preferencesControllerPatchPermissions(product, preferenceType, id, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * updates preference for a given preference id
         * @param {string} product
         * @param {string} preferenceType
         * @param {string} id
         * @param {UpdatePreferenceDto} updatePreferenceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesControllerUpdateById: function (product, preferenceType, id, updatePreferenceDto, options) {
            return localVarFp.preferencesControllerUpdateById(product, preferenceType, id, updatePreferenceDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreferencesControllerApiFactory = PreferencesControllerApiFactory;
/**
 * PreferencesControllerApi - object-oriented interface
 * @export
 * @class PreferencesControllerApi
 * @extends {BaseAPI}
 */
var PreferencesControllerApi = /** @class */ (function (_super) {
    __extends(PreferencesControllerApi, _super);
    function PreferencesControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * creates a preference
     * @param {string} product
     * @param {string} preferenceType
     * @param {CreatePreferenceDto} createPreferenceDto
     * @param {boolean} [allowMultiple]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerCreate = function (product, preferenceType, createPreferenceDto, allowMultiple, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerCreate(product, preferenceType, createPreferenceDto, allowMultiple, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * deletes preference for a given preference id
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerDeleteById = function (product, preferenceType, id, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerDeleteById(product, preferenceType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * deletes a user\'s permissions for a given preference id
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} id
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerDeletePermission = function (product, preferenceType, id, userId, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerDeletePermission(product, preferenceType, id, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * gets a collection of preference objects
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} [namespace]
     * @param {boolean} [shared]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerFindAll = function (product, preferenceType, namespace, shared, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerFindAll(product, preferenceType, namespace, shared, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * gets the permissions for a given preference id
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerGetPermissions = function (product, preferenceType, id, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerGetPermissions(product, preferenceType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * updates the permissions for a given preference id
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} id
     * @param {Set<object>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerPatchPermissions = function (product, preferenceType, id, requestBody, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerPatchPermissions(product, preferenceType, id, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * updates preference for a given preference id
     * @param {string} product
     * @param {string} preferenceType
     * @param {string} id
     * @param {UpdatePreferenceDto} updatePreferenceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesControllerApi
     */
    PreferencesControllerApi.prototype.preferencesControllerUpdateById = function (product, preferenceType, id, updatePreferenceDto, options) {
        var _this = this;
        return (0, exports.PreferencesControllerApiFp)(this.configuration).preferencesControllerUpdateById(product, preferenceType, id, updatePreferenceDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreferencesControllerApi;
}(base_1.BaseAPI));
exports.PreferencesControllerApi = PreferencesControllerApi;
